import {configureStore, combineReducers} from '@reduxjs/toolkit'
import AppApi from './network/Api'
import { FilterSlice } from './FilterSlice'

const rootReducer = combineReducers({
  Filter: FilterSlice.reducer,
  [AppApi.reducerPath]: AppApi.reducer,
})

const resettableRootReducer = (state: any, action: any) => {
  if (action.type === 'auth/logout') {
    return rootReducer(undefined, action)
  }
  return rootReducer(state, action)
}

export const store = configureStore({
  reducer: resettableRootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(AppApi.middleware),
  devTools: {
    actionSanitizer: (action) => {
      if (action.type?.startsWith('AppApi')) {
        return { ...action, payload: '[HIDDEN]' }
      }
      return action
    },
    stateSanitizer: (state: any) => {
      if (state[AppApi.reducerPath]) {
        return {
          ...state,
          [AppApi.reducerPath]: '[HIDDEN API STATE]'
        }
      }
      return state
    }
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
